<script setup lang="ts">
const props = defineProps({
  word: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);
const { documentText } = storeToRefs(thesaurusStore);
</script>

<template>
  <div 
    class="inline-flex items-center group"
    :class="{ 'pointer-events-none': disabled }"
  >
    <!-- <DocumentEditorReviewPanelThesaurusReplaceButton :text="props.word" /> -->
    <div
      class="rounded px-[2px] py-[1px] lowercase transition-colors"
      :class="{
        'underline cursor-pointer hover:bg-light-default': !disabled
      }"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped></style>
